
import TimeCollection from '@/components/TimeCollection.vue';
import copy from 'copy-to-clipboard'
import store from '@/store';
import Vue from 'vue'
import { CreatePollForSharingRequestMatchInput, EmailSendInput, SharingRequestMatchMatchDirectionEnum, MatchFiltersDto, MatchRequest, MatchResultsDto, RecommendedAction, SendMarkdownEmailInput, SharingRequestMatch, UserDto, UserSavedContactCreationFromSharingRequestMatch, UnitDto } from '@chainsight/networker-backend-axios-sdk';
import { Editor } from '@toast-ui/vue-editor';
import { zonedTimeToUtc, formatInTimeZone } from 'date-fns-tz';
import { format, startOfWeek, addWeeks, setHours, setMinutes, setSeconds, addDays, isAfter } from 'date-fns';
import i18n from '@/plugins/i18n'
import { translateMatches } from '@/utils/translator'

export default Vue.extend({
	name: 'BusinessMatchSharingMatchResults',
	components: {
		editor: Editor,
		TimeCollection
	},
	data() {
		return {
			SharingRequestMatchMatchDirectionEnum,
			overlay: false,
			writeMessageDialog: false,
			emailDialog: false,
			isCopied: false,
			isRequiredImageError: false,
			isFilterBarOpen: false,
			detailDrawer: false,
			mobileDetailDrawer: false,
			// Snackbar
			snackbar: false,
			snackbarText: '',
			snackbarColor: '#1976D1',
			snackbarLinkText: '',
			snackbarLinkRoute: '',
			snackbarTextAfter: '',
			isFilterDialogOpen: false,
			infoDialog: false,
			isSupplyDescExpanded: false,
			isDemandDescExpanded: false,
			timeCollectionDialog: false,
			emailSuccessDialog: false,
			sendEmailDialog: false,
			sendEmailSubject: '',
			sendEmailContent: '',
			sendEmailSharingUrl: '',
			sendEmailFixedContent: '',
			sendEmailLoading: false,
			resultNumbers: 0,
			allowResults: 0,
			countriesUpperBound: 3,
			industriesUpperBound: 3,
			firstName: '',
			lastName: '',
			jobTitle: '',
			companyName: '',
			companyWebsiteUrl: '',
			emailContentMarkdownForEdit: '',
			timeStrings: [] as string[],
			utcTimeStrings: [] as string[],
			demandDescriptions: [] as string[],
			supplyDescriptions: [] as string[],
			countries: [] as string[],
			industries: [] as string[],
			allCountries: [] as string[],
			matchRequest: {} as MatchRequest,
			matchFilterDto: {} as MatchFiltersDto,
			matchResultDetail: {
				unit: {
					id: 0,
					community: [] as {
						url: string,
						platform: string
					}[]
				}
			} as SharingRequestMatch,
			community: [] as {
				url: string,
				platform: string
			}[],
			booths: [] as { 
				url: string
				name: string 
			}[],
			contactList: [] as UnitDto[],
			contactListRefactor: [] as {
				firstName: string,
				lastName: string,
				title: string[],
				email: string,
				mobilePhone: string,
				community: {
					url: string | null,
					platform: string | null
				}[]
			}[],
			matchResults: {} as MatchResultsDto,
			recommendedAction: {} as RecommendedAction,
			userDto: {} as UserDto,
			sharingMatchResults: {
				sharingRequestMatches: [] as SharingRequestMatch[]
			},
			availabilitySettings: {
				timezone: "",
				availableDays: {
					monday: false,
					tuesday: false,
					wednesday: false,
					thursday: false,
					friday: false,
					saturday: false,
					sunday: false,
				},
				availableHours: {
					monday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					tuesday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					wednesday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					thursday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					friday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					saturday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					sunday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
				},
				meetingDuration: 60,
				repeatWeeks: 0,
				lastUpdated: ""
			},
			editorOptions: {
				hideModeSwitch: true,
				toolbarItems: [
					['heading', 'bold', 'italic', 'strike'],
					['hr', 'quote'],
					['ul', 'ol', 'task', 'indent', 'outdent'],
					['table', 'link'],
					['code', 'codeblock'],
					['scrollSync'],
				]
			},
			currentPage: 0,
			pageSize: 10,
			isLoadingMore: false,
			hasMorePages: true,
			hasSearched: false,
			// 搜尋進度條相關
			isSearchLoading: false,
			progressValue: 0,
			progressStatusText: '',
			progressInterval: null as any
		};
	},
	computed: {
		trackDto(){
			return store.state.track.trackDto
		},
		user() {
			return store.state.user;
		}
	},
	methods: {
		capitalizeFirst(text: string): string {
			if (!text) return ''
			return text.charAt(0).toUpperCase() + text.slice(1)
		},
		goToProfile() {
			this.$router.push('/profile')
		},
		onSearchStarted() {
			this.isSearchLoading = true
			this.progressValue = 0
			this.progressStatusText = String(this.$t('common.progressStatus.analyzingRequest'))

			// 啟動進度條動畫 - 15秒分成4等份
			let startTime = Date.now()

			this.progressInterval = setInterval(() => {
				const elapsed = Date.now() - startTime
				const timer = elapsed / 1000 // 轉換為秒

				if (timer >= 15) {
					// 超過15秒，保持在99%
					this.progressValue = 99
					this.progressStatusText = String(this.$t('common.progressStatus.generatingResults'))
					return
				}

				if (timer <= 3.75) {
					// 第一等分：分析您的需求
					this.progressStatusText = String(this.$t('common.progressStatus.analyzingRequest'))
					this.progressValue = (timer / 3.75) * 24.75  // 0-24.75%
				} else if (timer > 3.75 && timer <= 7.5) {
					// 第二等分：搜尋相關成員
					this.progressStatusText = String(this.$t('common.progressStatus.searchingMembers'))
					this.progressValue = 24.75 + ((timer - 3.75) / 3.75) * 24.75  // 24.75-49.5%
				} else if (timer > 7.5 && timer <= 11.25) {
					// 第三等分：智慧配對中
					this.progressStatusText = String(this.$t('common.progressStatus.smartMatching'))
					this.progressValue = 49.5 + ((timer - 7.5) / 3.75) * 24.75  // 49.5-74.25%
				} else if (timer > 11.25 && timer <= 15) {
					// 第四等分：生成結果
					this.progressStatusText = String(this.$t('common.progressStatus.generatingResults'))
					this.progressValue = 74.25 + ((timer - 11.25) / 3.75) * 24.75  // 74.25-99%
				}
			}, 100)  // 每100ms更新一次，讓動畫更平滑
		},
		onSearchFinished() {
			// 完成動畫 - 與 UserProfile.vue 相同的邏輯
			this.progressValue = 100
			clearInterval(this.progressInterval)
			setTimeout(() => {
				this.isSearchLoading = false
				this.progressValue = 0
				this.progressStatusText = ''
			}, 500)
		},
		normalizedWebsite(url: string) {
			if (!url) return ''; // 沒有網址就回傳空字串
			if (/^https?:\/\//i.test(url)) {
				return url;
			}
			return 'https://' + url;
		},
		handleEditorChange() {
			const editorInstance = this.$refs.markdownEditor as InstanceType<typeof Editor>;
			this.emailContentMarkdownForEdit = editorInstance.invoke('getMarkdown');
		},
		copy(text) {
			copy(text)
			this.isCopied = true
			setTimeout(() => {
				this.isCopied = false
			}, 1000)
		},
		scrollToMatch(matchId: string){
			this.$nextTick(() => {
					const el = document.getElementById('match-' + matchId)
					if (el) {
							el.scrollIntoView({ behavior: 'smooth', block: 'start' })
					}
			})
		},
		async getMe(){
			try {
				const resp = await this.api$.authApi.getMe();
				this.userDto = resp.data.data as UserDto;
			} catch (e) {
				console.error(e);
			}
		},
		onImageError(item : SharingRequestMatch) {
			if (item.unit && item.unit.entityName) {
				const firstLetter = item.unit.entityName.substring(0, 1).toUpperCase();
				item.unit.avatarUrl = require(`@/assets/business-match/alphabet/alphabet=${firstLetter}.png`);
			} else if(item.unit) {
				item.unit.avatarUrl = require('@/assets/business-match/alphabet/alphabet=Other.png');
			}
		},
		async handleSaveFromChild(payload) {
			this.overlay = true
			this.availabilitySettings = payload;

			// 處理時間
			const result: string[] = []
			const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
			const now = new Date()
			const thisWeekStart = startOfWeek(now, { weekStartsOn: 0 })
			// const repeatWeeks = this.availabilitySettings.repeatWeeks ?? 1;

			for (let weekOffset = 0; weekOffset < this.availabilitySettings.repeatWeeks + 1; weekOffset++) {
				for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
					const dayName = daysOfWeek[dayIndex]
					if (!this.availabilitySettings.availableDays[dayName]) continue;
					const hoursMap = this.availabilitySettings.availableHours[dayName]
					if (!hoursMap) continue

					for (let hour = 0; hour < 24; hour++) {
						if (!hoursMap[hour]) continue

						const date = setSeconds(
						setMinutes(setHours(addDays(addWeeks(thisWeekStart, weekOffset), dayIndex), hour),0),0)

						// 只取比現在晚的時間
						if (isAfter(date, now)) {
							result.push(format(date, 'yyyy-MM-dd HH:mm'))
						}
					}
				}
			}

			this.timeStrings = result;

			this.timeStrings.map(timeStr => {
				const date = zonedTimeToUtc(timeStr, this.availabilitySettings.timezone);
				this.utcTimeStrings.push(formatInTimeZone(date, "UTC", "yyyy-MM-dd HH:mm"));
			});

			this.timeCollectionDialog = false;
			this.emailDialog = false;

			const CreatePollForSharingRequestMatchInput : CreatePollForSharingRequestMatchInput = {
				userEmail: this.user.userDto?.email,
				to: this.matchResultDetail.unit?.email,
				sharingRequestMatchId: this.matchResultDetail.id,
				timeStrings: this.utcTimeStrings
			}

			let recommendedAction
			try{
				recommendedAction = await this.api$.sharingApi.createPollForSharingRequestMatch(CreatePollForSharingRequestMatchInput)
				this.recommendedAction = recommendedAction.data.data

				const editorInstance = this.$refs.markdownEditor as InstanceType<typeof Editor>;
				if(editorInstance){
					if(this.trackDto?.id == '7'){
						this.recommendedAction.text = this.recommendedAction.text?.replaceAll('bni', 'computex');
						this.recommendedAction.text = this.recommendedAction.text?.replaceAll('BNI', 'COMPUTEX');
						this.recommendedAction.title = this.recommendedAction.title?.replaceAll('BNI', 'COMPUTEX');
					}
					editorInstance.invoke('setMarkdown', this.recommendedAction.text as string);
				}else{
					if(this.trackDto?.id == '7'){
						this.recommendedAction.text = this.recommendedAction.text?.replaceAll('bni', 'computex');
						this.recommendedAction.text = this.recommendedAction.text?.replaceAll('BNI', 'COMPUTEX');
						this.recommendedAction.title = this.recommendedAction.title?.replaceAll('BNI', 'COMPUTEX');
					}
					this.emailContentMarkdownForEdit = this.recommendedAction.text as string
				}
			} catch (error) {
				console.error(error);
			}
			
			this.emailDialog = true;
			this.overlay = false
		},
		async getMatchRequest(){
			try {
				let getMatchRequestResp
				getMatchRequestResp = await this.api$.businessMatchApi.getMatchRequest(this.user.userDto?.id as string, this.trackDto?.id? this.trackDto.id : '0')
				this.matchRequest = getMatchRequestResp.data.data
			}catch (error) {
				console.error(error);
			}
		},
		async getSharingMatches(isLoadMore = false){
			if (isLoadMore && !this.hasMorePages) return;
			
			if (isLoadMore) {
				this.isLoadingMore = true;
				this.currentPage++;
			} else {
				this.overlay = true;
				this.currentPage = 0;
				this.hasMorePages = true;
			}
			
			let getSharingMatchesResp
			try {
				getSharingMatchesResp = await this.api$.sharingApi.getSharingMatchesPaginated(
					this.$route.params.sharingRequestId, 
					this.user.userDto?.id as string,
					this.currentPage,
					this.pageSize
				)
				const newData = getSharingMatchesResp.data.data

				// 處理 tags
				newData.content?.forEach(match => {
					if (match.unit?.tags) {
						const parsed: any = JSON.parse(JSON.stringify(match.unit.tags));
						const chapterValue = parsed.chapter;
						const regionValue = parsed.region;
						const typeValue = parsed.type;

						match.unit.tags = JSON.parse(
							JSON.stringify({
								...(chapterValue != null && { chapter: chapterValue }),
								...(regionValue != null && { region: regionValue }),
								...(typeValue != null && { type: typeValue })
							})
						);
					}
				});

				// 翻譯處理
				if (i18n.locale === 'zh') {
					await translateMatches(newData.content || [], 'zh-Hant')
				} else if (i18n.locale === 'en') {
					await translateMatches(newData.content || [], 'en-US')
				} else if (i18n.locale === 'ja') {
					await translateMatches(newData.content || [], 'ja')
				}
				
				if (isLoadMore) {
					// 追加新資料
					if (!this.sharingMatchResults.sharingRequestMatches) {
						this.sharingMatchResults.sharingRequestMatches = [];
					}
					const newMatches = newData.content || [];
					this.sharingMatchResults.sharingRequestMatches = this.sharingMatchResults.sharingRequestMatches.concat(newMatches);
					this.hasMorePages = newData.content && newData.content.length === this.pageSize;
				} else {
					// 第一次載入或重新載入
					this.sharingMatchResults = {
						sharingRequestMatches: newData.content || []
					}
					this.hasMorePages = newData.content && newData.content.length === this.pageSize;
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.hasSearched = true;
				this.isLoadingMore = false;
				this.overlay = false;
			}
		},
		handleScroll(event: Event) {
			// 非付費會員不能載入更多（track 20 除外）
			if (this.userDto.isPaidMember === false && this.trackDto?.id !== '20') return;

			const element = event.target as HTMLElement;
			const scrollHeight = element.scrollHeight;
			const scrollTop = element.scrollTop;
			const clientHeight = element.clientHeight;

			// 當滾動到底部附近時載入更多
			if (scrollHeight - scrollTop <= clientHeight + 100) {
				this.loadMore();
			}
		},
		loadMore() {
			// 非付費會員不能載入更多（track 20 除外）
			if (this.userDto.isPaidMember === false && this.trackDto?.id !== '20') return;
			if (this.isLoadingMore || !this.hasMorePages) return;
			this.getSharingMatches(true);
		},
		async insertSharingMatchResultDetail(sharingRequestMatch : SharingRequestMatch){
			this.overlay = true
			this.matchResultDetail = sharingRequestMatch
			this.community = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.community)) as { url: string; platform: string }[]
			this.booths = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.booths)) as { url: string; name: string }[]
			const allowedPlatforms = ['linkedin', 'twitter', 'whatsapp', 'github'];
			if(this.community){
				this.community = this.community.filter(item => {
					return allowedPlatforms.includes(item.platform);
				});
			}
			this.demandDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.demands || "[]")).map((d) => d.description ?? d.description_short ?? d.descriptionShort);
			this.supplyDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.supplies || "[]")).map((s) => s.description ?? s.description_short ?? s.descriptionShort);

			this.detailDrawer = true
			this.mobileDetailDrawer = true
			this.overlay = false
		},
		async saveContact(item : SharingRequestMatch){
			const userSavedContactCreation : UserSavedContactCreationFromSharingRequestMatch = {
				sharingRequestMatchId: item.id,
				unitId: item.unit?.id,
				productTrackId: this.trackDto?.id ? this.trackDto.id : '0'
			}
			try{
				await this.api$.savedContactApi.createFromSharingRequest(this.user.userDto?.id as string, userSavedContactCreation)
				// 直接更新對應項目的 savedContact 欄位
				const targetMatch = this.sharingMatchResults.sharingRequestMatches?.find(m => m.id === item.id)
				if (targetMatch) {
					targetMatch.savedContact = true
				}
				// 如果 detailDrawer 開啟且是同一個項目，也更新 matchResultDetail
				if (this.matchResultDetail && this.matchResultDetail.id === item.id) {
					this.matchResultDetail.savedContact = true
				}
			}catch (error) {
				console.error('Error saving contact:', error);
			}
		},
		async addUnitAsFriend(unitId: number) {
			const userId = this.user.userDto?.id as string
			if (!userId || !unitId) return null

			try {
				const response = await this.api$.userFriendApi.addUnitAsFriend(userId, unitId)
				return response.data.data
			} catch (error) {
				console.error('Failed to add unit as friend:', error)
				return null
			}
		},
		linkifyText(text: string): string {
			const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			return escaped.replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" class="primary--text font-weight-medium" style="word-break: break-all;">$1</a>')
		},
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		async openSendEmailDialog(match: any) {
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			try {
				const userId = this.user.userDto?.id as string
				const response = await this.api$.sharingUserApi.createSharingUser(userId)
				const sharingId = response.data.data?.id

				let baseUrl = process.env.VUE_APP_BASE_URL as string
				if (!baseUrl.includes('localhost') && this.trackDto?.name && this.trackDto?.id !== '0') {
					baseUrl = baseUrl.replace('//ws', `//${this.trackDto.name}.ws`)
				}
				this.sendEmailSharingUrl = `${baseUrl}/nl-match/profile-sharing/${sharingId}`
				this.sendEmailFixedContent = `[View Business Card →]: ${this.sendEmailSharingUrl}`

				this.sendEmailDialog = true
			} catch (error) {
				console.error('Failed to create sharing user:', error)
			}
		},
		closeSendEmailDialog() {
			this.sendEmailDialog = false
		},
		async sendEmailToUnit() {
			if (!this.sendEmailSubject.trim() || !this.sendEmailContent.trim()) return

			this.closeSendEmailDialog()
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			this.overlay = true
			try {
				const fullContent = `${this.sendEmailContent}\n\n${this.sendEmailFixedContent}`

				const requestBody = {
					userId: this.user.userDto?.id as string,
					unitId: this.matchResultDetail.unit?.id,
					productTrackId: this.trackDto?.id,
					subject: this.sendEmailSubject,
					content: fullContent,
					sharingRequestMatchId: this.matchResultDetail.id
				}

				await this.api$.emailApi.sendEmailToUnit(requestBody)

				this.sendEmailSubject = ''
				this.sendEmailContent = ''
				this.sendEmailFixedContent = ''

				this.snackbarColor = '#1976D1'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessAddedTo'))
				this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessMyContacts'))
				this.snackbarLinkRoute = '/match/my-contacts'
				this.snackbarTextAfter = String(this.$t('businessMatchResults.detailDrawer.connectSuccessNotifiedByEmail'))
				this.snackbar = true
			} catch (error) {
				console.error('Failed to send email:', error)
				this.snackbarColor = 'error'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.emailSendFailed'))
				this.snackbarLinkText = ''
				this.snackbarTextAfter = ''
				this.snackbar = true
			} finally {
				this.overlay = false
			}
		},
		async sendTemplateEmail(input: SendMarkdownEmailInput) {
			try {
				await this.api$.emailApi.sendEmail1(input)
			} catch (error) {
				console.error('Failed to send email:', error)
			}
		},
		async handleConnect(match: SharingRequestMatch) {
			const unitId = match.unit?.id
			const productTrackId = match.unit?.productTrackId

			if (!unitId) return

			// 檢查使用者個人資料是否完整
			if (!this.userDto?.companyTitle || !this.userDto?.email || !this.userDto?.companyName) {
				this.snackbarColor = 'warning'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.incompleteProfile'))
				this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.goToProfile'))
				this.snackbarLinkRoute = '/profile'
				this.snackbarTextAfter = ''
				this.snackbar = true
				return
			}

			// 若已聯繫過，顯示提示訊息並返回
			if (match.savedContact === true) {
				this.snackbarColor = '#1976D1'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.alreadyContacted'))
				this.snackbarLinkText = ''
				this.snackbarLinkRoute = ''
				this.snackbarTextAfter = ''
				this.snackbar = true
				return
			}

			this.overlay = true

			// 關閉抽屜
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			try {
				if (productTrackId === '0') {
					const toEmail = match.unit?.email

					// 同時呼叫 saveContact、addUnitAsFriend
					const promises: Promise<any>[] = [
						this.saveContact(match),
						this.addUnitAsFriend(unitId)
					]
					await Promise.all(promises)

					if (toEmail) {
						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const userName = `${match.unit?.firstName || ''} ${match.unit?.lastName || ''}`.trim()

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''
						const senderLookingForItems = userDto?.demands?.map(d => d.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderLookingFor = senderLookingForItems.length > 0 ? '\n  - ' + senderLookingForItems.join('\n  - ') : ''
						const senderOffersItems = userDto?.supplies?.map(s => s.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderOffers = senderOffersItems.length > 0 ? '\n  - ' + senderOffersItems.join('\n  - ') : ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.connectUser.subject'))
						let content = String(this.$t('emailTemplates.connectUser.content'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						content = content
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_company\}/g, senderCompany)

						// 條件式行：Title
						if (senderTitle) {
							content = content.replace(/\{sender_title\}/g, senderTitle)
						} else {
							content = content.replace(/\n- Title: \{sender_title\}/g, '')
						}

						// 條件式行：Looking for
						if (senderLookingFor) {
							content = content.replace(/\{sender_looking_for\}/g, senderLookingFor)
						} else {
							content = content.replace(/\n- Looking for: \{sender_looking_for\}/g, '')
						}

						// 條件式行：Offers
						if (senderOffers) {
							content = content.replace(/\{sender_offers\}/g, senderOffers)
						} else {
							content = content.replace(/\n- Offers: \{sender_offers\}/g, '')
						}

						// [Login to Accept →] 後面加入 NonLoginChatRoom 連結
						content = content.replace('[Login to Accept →]', `[Login to Accept →]: ${nonLoginChatUrl}`)

						// 發送信件
						await this.sendTemplateEmail({
							toAddrs: [toEmail],
							subject,
							content
						})
					}

					// 標記為已聯繫
					match.savedContact = true

					// 顯示成功訊息
					this.snackbarColor = '#1976D1'
					this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessConnected'))
					this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessStartConversation'))
					this.snackbarLinkRoute = '/chat'
					this.snackbarTextAfter = ''
					this.snackbar = true
				} else {
					const toEmail = match.unit?.email

					// 同時呼叫 saveContact
					const promises: Promise<any>[] = [
						this.saveContact(match)
					]
					await Promise.all(promises)

					if (toEmail) {
						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const trackId = this.trackDto?.id ?? ''
						let userName = ''
						if (['4', '7'].includes(trackId)) {
							userName = match.unit?.entityName || ''
						} else {
							userName = `${match.unit?.firstName || ''} ${match.unit?.lastName || ''}`.trim()
						}

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''
						const senderIndustry = userDto?.companyIndustry?.join(', ') || ''
						const senderLookingForItems = userDto?.demands?.map(d => d.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderLookingFor = senderLookingForItems.length > 0 ? '\n  - ' + senderLookingForItems.join('\n  - ') : ''
						const senderOffersItems = userDto?.supplies?.map(s => s.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderOffers = senderOffersItems.length > 0 ? '\n  - ' + senderOffersItems.join('\n  - ') : ''
						const senderMatchReasonItems = match.summaries?.filter(Boolean) || []
						const senderMatchReason = senderMatchReasonItems.length > 0 ? '\n  - ' + senderMatchReasonItems.join('\n  - ') : ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.connectNonUser.subject'))
						let content = String(this.$t('emailTemplates.connectNonUser.content'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						content = content
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_company\}/g, senderCompany)
							.replace(/\{sender_industry\}/g, senderIndustry)

						// 條件式行：Title（在 greeting 行中）
						if (senderTitle) {
							content = content.replace(/\{sender_title\}/g, senderTitle)
						} else {
							content = content.replace(/, \{sender_title\}/g, '')
						}

						// 條件式行：Looking for
						if (senderLookingFor) {
							content = content.replace(/\{sender_looking_for\}/g, senderLookingFor)
						} else {
							content = content.replace(/\n- Looking for: \{sender_looking_for\}/g, '')
						}

						// 條件式行：Offers
						if (senderOffers) {
							content = content.replace(/\{sender_offers\}/g, senderOffers)
						} else {
							content = content.replace(/\n- Offers: \{sender_offers\}/g, '')
						}

						// Why they want to connect
						if (senderMatchReason) {
							content = content.replace(/\{sender_match_reason\}/g, senderMatchReason)
						} else {
							content = content.replace(/\n- Why they want to connect: \{sender_match_reason\}/g, '')
						}

						// [Register to Accept →] 後面加入 NonLoginChatRoom 連結
						content = content.replace('[Register to Accept →]', `[Register to Accept →]: ${nonLoginChatUrl}`)

						// 發送信件
						await this.sendTemplateEmail({
							toAddrs: [toEmail],
							subject,
							content
						})
					}

					// 標記為已聯繫
					match.savedContact = true

					// 顯示成功訊息
					this.snackbarColor = '#1976D1'
					this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessMyContacts'))
					this.snackbarLinkRoute = '/match/my-contacts'
					if (toEmail) {
						this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessAddedTo'))
						this.snackbarTextAfter = String(this.$t('businessMatchResults.detailDrawer.connectSuccessNotifiedByEmail'))
					} else {
						this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessConnectedAddedTo'))
						this.snackbarTextAfter = ''
					}
					this.snackbar = true
				}
			} finally {
				this.overlay = false
			}
		},
		async handleMessage(match: SharingRequestMatch) {
			const unitId = match.unit?.id
			const productTrackId = match.unit?.productTrackId

			if (!unitId) return

			this.overlay = true

			// 關閉抽屜
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			try {
				if (productTrackId === '0') {
					const toEmail = match.unit?.email

					// 同時呼叫 saveContact、addUnitAsFriend
					const promises: Promise<any>[] = [
						this.saveContact(match),
						this.addUnitAsFriend(unitId)
					]
					const [, friendResponse] = await Promise.all(promises)

					// 寄送 messageUser 模板信件
					if (toEmail) {
						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const userName = `${match.unit?.firstName || ''} ${match.unit?.lastName || ''}`.trim()

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''
						const senderLookingForItems = userDto?.demands?.map(d => d.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderLookingFor = senderLookingForItems.length > 0 ? '\n  - ' + senderLookingForItems.join('\n  - ') : ''
						const senderOffersItems = userDto?.supplies?.map(s => s.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderOffers = senderOffersItems.length > 0 ? '\n  - ' + senderOffersItems.join('\n  - ') : ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.messageUser.subject'))
						let emailContent = String(this.$t('emailTemplates.messageUser.content'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						emailContent = emailContent
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_company\}/g, senderCompany)

						// 條件式：Title
						if (senderTitle) {
							emailContent = emailContent.replace(/\{sender_title\}/g, senderTitle)
						} else {
							emailContent = emailContent.replace(/\n- Title: \{sender_title\}/g, '')
						}

						// 條件式：Looking for
						if (senderLookingFor) {
							emailContent = emailContent.replace(/\{sender_looking_for\}/g, senderLookingFor)
						} else {
							emailContent = emailContent.replace(/\n- Looking for: \{sender_looking_for\}/g, '')
						}

						// 條件式：Offers
						if (senderOffers) {
							emailContent = emailContent.replace(/\{sender_offers\}/g, senderOffers)
						} else {
							emailContent = emailContent.replace(/\n- Offers: \{sender_offers\}/g, '')
						}

						// 替換連結（使用 NonLoginChatRoom URL）
						emailContent = emailContent.replace('[Login to Accept →]', `[Login to Accept →]: ${nonLoginChatUrl}`)

						// 發送信件
						await this.sendTemplateEmail({
							toAddrs: [toEmail],
							subject,
							content: emailContent
						})
					}

					// 跳轉到 chat
					if (friendResponse?.friendUserId) {
						localStorage.setItem('TARGET_USER_ID', friendResponse.friendUserId)
						this.$router.push('/chat')
					}
				} else {
					const toEmail = match.unit?.email

					// 同時呼叫 saveContact，有 email 時也一起建立 sharingUser
					const userId = this.user.userDto?.id as string
					const promises: Promise<any>[] = [
						this.saveContact(match)
					]
					if (toEmail) {
						promises.push(this.api$.sharingUserApi.createSharingUser(userId))
					}
					const results = await Promise.all(promises)

					if (toEmail) {
						const sharingResponse = results[1]
						const sharingId = sharingResponse.data.data?.id
						let baseUrl = process.env.VUE_APP_BASE_URL as string
						if (!baseUrl.includes('localhost') && this.trackDto?.name && this.trackDto?.id !== '0') {
							baseUrl = baseUrl.replace('//ws', `//${this.trackDto.name}.ws`)
						}
						const sharingUrl = `${baseUrl}/nl-match/profile-sharing/${sharingId}`

						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const trackId = this.trackDto?.id ?? ''
						let userName = ''
						if (['4', '7'].includes(trackId)) {
							userName = match.unit?.entityName || ''
						} else {
							userName = `${match.unit?.firstName || ''} ${match.unit?.lastName || ''}`.trim()
						}

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.messageNonUser.subject'))
						let templateContent = String(this.$t('emailTemplates.messageNonUser.content'))
						let fixedContent = String(this.$t('emailTemplates.messageNonUser.fixedContent'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						templateContent = templateContent
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_title\}/g, senderTitle)
							.replace(/\{sender_company\}/g, senderCompany)

						// 替換連結
						templateContent = templateContent.replace('[View Business Card →]', `[View Business Card →]: ${sharingUrl}`)
						fixedContent = fixedContent.replace('[Register to Message →]', `[Register to Message →]: ${nonLoginChatUrl}`)

						// 帶入主旨、內文、固定區塊
						this.sendEmailSubject = subject
						this.sendEmailContent = templateContent
						this.sendEmailFixedContent = fixedContent
						this.sendEmailSharingUrl = sharingUrl

						// 打開 dialog
						this.sendEmailDialog = true
					}
				}
			} finally {
				this.overlay = false
			}
		},
		async deleteSavedContact(id: string | undefined, unitId: number | undefined){
			this.overlay = true
			try{
				await this.api$.savedContactApi.deleteByUserIdnProductTrackIdnUnitId(this.user.userDto?.id as string, this.trackDto?.id as string, unitId as number)
				// 直接更新對應項目的 savedContact 欄位
				const targetMatch = this.sharingMatchResults.sharingRequestMatches?.find(m => m.id === id)
				if (targetMatch) {
					targetMatch.savedContact = false
				}
				// 如果 detailDrawer 開啟且是同一個項目，也更新 matchResultDetail
				if (this.matchResultDetail && this.matchResultDetail.id === id) {
					this.matchResultDetail.savedContact = false
				}
			}catch (error) {
				console.error('Error deleting saved contact:', error);
			}
			this.overlay = false
		},
		async getEmail(sharingRequestMatchId){
			this.overlay = true
			let getRecommendedActionsResp
			try{
				getRecommendedActionsResp = await this.api$.sharingApi.getRecommendedAction(sharingRequestMatchId, this.trackDto?.id? this.trackDto.id : '0', localStorage.getItem('locale') ?? 'en')
				this.recommendedAction = getRecommendedActionsResp.data.data

				if(this.userDto.availabilityTime){
					await this.handleSaveFromChild(this.userDto.availabilityTime)
				} else{
					const editorInstance = this.$refs.markdownEditor as InstanceType<typeof Editor>;
					if(editorInstance){
						if(this.trackDto?.id == '7'){
							this.recommendedAction.text = this.recommendedAction.text?.replaceAll('bni', 'computex');
							this.recommendedAction.text = this.recommendedAction.text?.replaceAll('BNI', 'COMPUTEX');
							this.recommendedAction.title = this.recommendedAction.title?.replaceAll('BNI', 'COMPUTEX');
						}
						editorInstance.invoke('setMarkdown', this.recommendedAction.text as string);
					}else{
						if(this.trackDto?.id == '7'){
							this.recommendedAction.text = this.recommendedAction.text?.replaceAll('bni', 'computex');
							this.recommendedAction.text = this.recommendedAction.text?.replaceAll('BNI', 'COMPUTEX');
							this.recommendedAction.title = this.recommendedAction.title?.replaceAll('BNI', 'COMPUTEX');
						}
						this.emailContentMarkdownForEdit = this.recommendedAction.text as string
					}
				}

				this.emailDialog = true
			}catch (error) {
				console.error(error);
			}
			this.overlay = false
		},
		async sendEmail(){
			this.overlay = true
			this.emailDialog = false

			const emailSendInput: EmailSendInput = {
				productTrackId: this.trackDto?.id ? this.trackDto.id : '0',
				userEmail: this.user.userDto?.email,
				to: this.matchResultDetail.unit?.email,
				sharingRequestMatchId: this.matchResultDetail.id,
				subject: this.recommendedAction?.title,
				content: this.emailContentMarkdownForEdit,
			}

			let sendEmailResp
			try {
				sendEmailResp = await this.api$.businessMatchApi.sendEmail(this.user.userDto?.id as string, emailSendInput)

				this.emailSuccessDialog = true
			}catch (error) {
				console.error(error);
			}
			this.overlay = false
		},
		async downloadCSV(){
			const trackId = this.trackDto?.id || ''
			const tmpUserId = this.$route.params.tmpUserId;
			try {
				const downloadUrl = process.env.VUE_APP_API_BASE_URL+`/api/user/${tmpUserId}/business-match/download-match-results?productTrackId=${trackId}`;
				window.open(downloadUrl, '_blank');
			} catch (error) {
				console.error('Error downloading CSV:', error);
			}
		}
	},
	mounted() {
		// 監聽搜尋事件
		this.eventHub$.$on('searchStarted', this.onSearchStarted)
		this.eventHub$.$on('searchFinished', this.onSearchFinished)
	},
	beforeDestroy() {
		// 移除 eventHub 監聽器
		this.eventHub$.$off('searchStarted', this.onSearchStarted)
		this.eventHub$.$off('searchFinished', this.onSearchFinished)
	},
	async created(){
		this.overlay = true
		await this.getSharingMatches()
		await this.getMe()
		await this.$nextTick()
		
		if(localStorage.getItem('SHARING_MATCH_ID')){
			const matchId = localStorage.getItem('SHARING_MATCH_ID') as string
			this.scrollToMatch(matchId)
			const matchResult = this.sharingMatchResults.sharingRequestMatches?.find(match => match.id === matchId)
			if(matchResult && localStorage.getItem('ACTION') === 'connect'){
				await this.handleConnect(matchResult)
				this.overlay = true
				await this.getSharingMatches(false)
			}
			localStorage.removeItem('SHARING_MATCH_ID')
			localStorage.removeItem('ACTION')
		}
		this.overlay = false
	},
	watch: {
		'$i18n.locale': {
			immediate: false,
			async handler() {
				this.overlay = true
				
				// 只翻譯現有資料，不重新呼叫 API
				if (this.sharingMatchResults.sharingRequestMatches && this.sharingMatchResults.sharingRequestMatches.length > 0) {
					if (i18n.locale === 'zh') {
						await translateMatches(this.sharingMatchResults.sharingRequestMatches, 'zh-Hant')
					} else if (i18n.locale === 'en') {
						await translateMatches(this.sharingMatchResults.sharingRequestMatches, 'en-US')
					} else if (i18n.locale === 'ja') {
						await translateMatches(this.sharingMatchResults.sharingRequestMatches, 'ja')
					}
				}
				
				this.overlay = false
			}
		}
	}
});
